import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
declare var $: any;

@Component({
  selector: 'smart-preload-plot-detail',
  templateUrl: './preload-plot-detail.component.html',
  styleUrls: ['./preload-plot-detail.component.scss']
})
export class PreloadPlotDetailComponent implements OnInit {
  plotId: string;
  farmId: string;
  cropId: string;
  zoneId: string;
  userrole = sessionStorage.getItem("role");

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private farmService: FarmService,

  ) {
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.farmId = this.route.snapshot.queryParams["farmId"];
    this.cropId = this.route.snapshot.queryParams["cropId"];
    this.zoneId = this.route.snapshot.queryParams["zoneId"];
  }

  ngOnInit() {
    this.getPlot()
  }

  async getPlot() {
   
    this.farmService.getPlotDetailByID(this.plotId).subscribe(async success => {
      if (success.code == 200) {
        let cropId = success.data[0].crop._id
        this.router.navigate(["/plot-detail"], { queryParams: { farmId: this.farmId, plotId: this.plotId, cropId : cropId, zoneId : this.zoneId } })
      } else {
        if(this.userrole == 'farm_manager' || this.userrole == 'admin'){
          this.router.navigate(["/create-crop"], { queryParams: { zoneId: this.zoneId, plotId: this.plotId } })
        }else{
          $('#Failmodal').modal('show');
        }
      }
    });
  }

  returnDashboard(){
    this.router.navigate(["/dashboard"]);
  }
}
